import StringUtils from './string';
const $forEach = require('lodash.foreach');
const $cloneDeep = require('lodash.clonedeep');
class ProductUtils {
  constructor(product) {
    this.product = product && typeof product === 'object' ? product : {};
  }

  getAddToBagFlowStatus(source = null) {
    if (
      ['sellable_products', 'bundle_virtual', 'bundle_physical'].indexOf(
        this.product.classification,
      ) > -1 ||
      source === 'babyRegistry'
    ) {
      if (
        ['bundle_virtual', 'bundle_physical'].includes(
          this.product.classification,
        )
      ) {
        const findPackCombination =
          this.product.pack_detail &&
          this.product.pack_detail.findIndex(
            (res) => res.combinations && res.combinations.length > 1,
          );
        return (!isNaN(findPackCombination) && findPackCombination > -1) ||
          (this.product.combinations && this.product.combinations.length > 1)
          ? 'modal_multi_cart'
          : 'modal_single_cart';
      } else {
        return this.product.combinations && this.product.combinations.length > 1
          ? 'modal_multi_cart'
          : 'modal_single_cart';
      }
    } else {
      return 'product_detail';
    }
  }

  getClassification() {
    // each product has different classification
    return this.product.classification;
  }

  getCombinationName(combination) {
    const data = combination ? combination : this.product.default_combination;
    let groupAttribute = '';
    let attribute;
    if (Object.keys(data).length) {
      for (attribute in data.attributes) {
        if (data.attributes?.attribute && attribute !== 'non_specify') {
          groupAttribute += groupAttribute ? ' - ' : '';
          groupAttribute += `${attribute}: ${data.attributes[attribute].name}`;
        } else if (data.attributes && attribute !== 'non_specify') {
          // response from flash sale api
          groupAttribute += groupAttribute ? ' - ' : '';
          groupAttribute += `${data.attributes[attribute].name}`;
        }
      }
      return StringUtils.ucWordsAttributeName(groupAttribute);
    } else {
      return '';
    }
  }

  getImageDefaultProductGrid() {
    const imageDefault =
      this.product.images &&
      Array.isArray(this.product.images) &&
      this.product.images.length;
    const defaultImageCombination =
      this.product.default_combination &&
      this.product.default_combination.images &&
      Array.isArray(this.product.default_combination.images) &&
      this.product.default_combination.images.length;
    if (imageDefault || defaultImageCombination) {
      let imageCover;
      if (defaultImageCombination) {
        const imageCoverLilla = this.product.default_combination.images.find(
          (res) => res.is_lilla_cover,
        );
        if (imageCoverLilla) {
          imageCover = imageCoverLilla.url;
        }
      }
      if (imageDefault) {
        const imageCoverLilla = this.product.images.find(
          (res) => res.is_lilla_cover,
        );
        if (imageCoverLilla) {
          imageCover = imageCoverLilla.url;
        }
      }
      if (!imageCover && imageDefault) {
        imageCover = this.product.images[0].url;
      }
      if (!imageCover && defaultImageCombination) {
        imageCover = this.product.default_combination.images[0].url;
      }
      return imageCover;
    }
  }

  getProductSlug(value) {
    if (typeof value === 'string') {
      let s = value.toLowerCase();
      s = s
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '-')
        .replace(/^-+|-+$/g, '');
      return s;
    }

    return null;
  }

  getProductUriSchemes() {
    const categoryName =
      this.product.default_category && this.product.default_category.name
        ? this.getProductSlug(this.product.default_category.name)
        : 'product';
    let slug = this.product.slug || '';
    if (!slug) {
      slug = this.product.name
        ? this.getProductSlug(this.product.name)
        : 'default';
    }

    const imageDefault = this.getImageDefaultProductGrid();
    const brandName = this.product.brand?.name || '';
    return { categoryName, slug, og_image: imageDefault, brandName };
  }

  isShowReviewsOrRatings() {
    return ['bundle_virtual', 'egift'].indexOf(this.product.classification) < 0;
  }

  isDiscount() {
    return Boolean(
      this.product.is_new ||
        this.product.is_sale ||
        this.product.discount_range,
    );
  }

  isInStock() {
    // For bundle products
    if (
      ['bundle_virtual', 'bundle_physical'].includes(
        this.product.classification,
      )
    ) {
      if (
        this.product?.pack_detail &&
        Array.isArray(this.product?.pack_detail) &&
        this.product?.pack_detail.length > 0
      ) {
        const bundleNotInStock = this.product.is_in_stock === false;

        if (bundleNotInStock && !this.product.is_in_stock_lulla) {
          return false;
        }

        const allPackItemsInStock = this.product.pack_detail.every(
          (packItem) => {
            if (
              packItem.is_out_of_stock_lilla ||
              packItem.is_out_of_stock_lulla
            ) {
              return false;
            }

            if (packItem.is_out_of_stock_sociolla) {
              return false;
            }

            if (typeof packItem.stock === 'number') {
              return packItem.stock > 0;
            }
            if (
              Array.isArray(packItem.combinations) &&
              packItem.combinations.length > 0
            ) {
              return packItem.combinations.every(
                (comb) =>
                  !comb.is_out_of_stock_lulla &&
                  !comb.is_out_of_stock_lilla &&
                  !comb.is_out_of_stock_sociolla &&
                  (comb.stock == null || comb.stock > 0),
              );
            }

            return true;
          },
        );

        if (this.product?.is_out_of_stock_lilla) {
          return false;
        }

        if (Object.prototype.hasOwnProperty.call(this.product, 'is_in_stock')) {
          return this.product.is_in_stock;
        }

        return allPackItemsInStock;
      }
    }

    // For non-bundle products, use existing logic
    if (
      Object.prototype.hasOwnProperty.call(this?.product, 'is_in_stock') &&
      !this.product.is_in_stock &&
      !this.product.is_in_stock_lulla
    ) {
      return false;
    }

    if (
      Object.prototype.hasOwnProperty.call(this?.product, 'is_in_stock_lulla')
    ) {
      if (this.product.is_out_of_stock_lilla) {
        return false;
      }

      if (
        Array.isArray(this.product?.combinations) &&
        this.product.combinations.length > 0
      ) {
        const isOutOfStockCombinations = this.product.combinations.every(
          (obj) => obj?.is_out_of_stock_lulla === true,
        );

        return !isOutOfStockCombinations;
      }

      return this.product.is_in_stock_lulla;
    }

    if (
      this.product &&
      ('is_out_of_stock_lulla' in this.product ||
        'is_out_of_stock_lilla' in this.product)
    ) {
      return !(
        this.product?.is_out_of_stock_lilla ??
        this.product?.is_out_of_stock_lulla
      );
    }
    if (Object.prototype.hasOwnProperty.call(this?.product, 'is_in_stock')) {
      return this.product.is_in_stock;
    }
    return false;
  }

  // check stock in product detail
  isOutStockOfCombination(defaultCombination) {
    const isInStock =
      this.product.is_in_stock && !this.product.is_out_of_stock_lilla
        ? true
        : false;

    if (!isInStock) {
      return true;
    }

    return defaultCombination.is_out_of_stock_lilla
      ? defaultCombination.is_out_of_stock_lilla
      : defaultCombination.is_out_of_stock_lulla;
  }

  isExclusiveProduct() {
    return this.product.is_exclusive;
  }

  isNewProduct() {
    return this.product.is_new;
  }

  isBundleProduct() {
    return (
      this.product.classification === 'bundle_virtual' ||
      this.product.classification === 'bundle_physical'
    );
  }

  isEgiftProduct() {
    return this.product.classification === 'egift';
  }

  isPreOrderProduct() {
    return this.product.is_pre_order;
  }

  isBuyOneGetOneProduct() {
    return (
      this.product.default_combination &&
      this.product.default_combination.is_buy_one_get_one_free
    );
  }

  isBabyRegistryProduct() {
    return Boolean(this.product.baby_registry_id);
  }

  isExclusiveDealsProduct() {
    // if product contains is_exclusive_flag then show the label on product grid
    let isContainsExclusiveDeals = false;

    if (this.product?.default_combination?.is_exclusive_deals) {
      isContainsExclusiveDeals = true;
    }

    $forEach(this.product?.combinations, (combination) => {
      if (combination.is_exclusive_deals) {
        isContainsExclusiveDeals = true;
        return false;
      }
    });

    return this.product?.combinations?.length && isContainsExclusiveDeals;
  }

  // === //

  isAllPreOrderProducts() {
    return (
      this.product?.combinations?.length &&
      this.product?.combinations.every((product) => product.is_pre_order)
    );
  }

  isHalalProduct() {
    if (this.product?.classification === 'egift') {
      return false;
    }

    const isDefaultCombinationHalal = Boolean(
      this.product?.default_combination?.halal_status === 'halal',
    );
    if (isDefaultCombinationHalal) {
      return true;
    }

    if (this.product?.combinations?.length) {
      const isHalalCombination = this.product.combinations.some(
        (combination) => combination.halal_status === 'halal',
      );
      return isHalalCombination;
    }

    return false;
  }

  // get key combination name
  getKeyCombinationName(combination) {
    const data = combination ? combination : this.product.default_combination;
    let groupAttribute = '';
    let attribute;
    if (Object.keys(data).length) {
      for (attribute in data.attributes) {
        if (data.attributes?.attribute && attribute !== 'non_specify') {
          groupAttribute += groupAttribute ? ' - ' : '';
          groupAttribute += `${attribute}`;
        } else if (data.attributes && attribute !== 'non_specify') {
          // response from flash sale api
          groupAttribute += groupAttribute ? ' - ' : '';
          groupAttribute += `${attribute}`;
        }
      }
      return groupAttribute;
    } else {
      return '';
    }
  }

  static checkPreOrderProductCombination(combination) {
    return combination.is_pre_order;
  }

  static checkBabyRegistryProduct(product) {
    return Boolean(product.baby_registry_id);
  }

  /*
   * Get detail data for cart who user wasn't logged in
   * @param {object}
   * @return {object}
   */
  getDetailDataNotLogin(productData) {
    const isBundle =
      productData.is_pack ||
      ['bundle_virtual', 'bundle_physical'].includes(
        productData.classification,
      );

    if (isBundle && productData.pack_detail && productData.pack_detail.length) {
      const combination_id =
        productData?.detail?._id || productData?.default_combination?._id;
      const combination =
        productData?.combination ||
        productData?.default_combination?.combination;
      const detail = productData?.detail
        ? productData?.detail
        : {
            ...productData.default_combination,
            id: productData.id,
            slug: productData.slug,
            name: productData.name,
            brand: productData.brand,
            is_available: true,
            combination: productData.default_combination,
            image: productData.images.find((img) => img.is_cover),
          };
      const pack_detail = productData.pack_detail.map((item) => ({
        ...item,
        _id: item?.combination_id,
        product_id: item.id,
        combination_id: item?.combination_id,
        quantity: item?.quantity ?? 1,
        is_available: true,
        detail: {
          id: item.id,
          name: item.name,
          brand: productData.brand,
          is_available: true,
          combination:
            item.combinations.length > 0
              ? item.combinations[0]
              : item.combinations,
          image: item.images[0],
        },
      }));
      // Bundle products
      return {
        ...productData,
        combination_id,
        combination,
        detail,
        is_selected: true,
        is_pack: true,
        is_available: true,
        pack_detail,
      };
    } else {
      // for non-bundle products
      const combinationId =
        productData.default_combination && productData.default_combination._id
          ? productData?.default_combination?._id
          : productData.combinations &&
            Array.isArray(productData.combinations) &&
            productData.combinations.length
          ? productData.combinations[0]._id
          : null;

      const selectedCombination = productData.combinations?.find(
        (comb) => comb._id === combinationId,
      );

      return {
        ...productData,
        combination_id: selectedCombination?._id,
        detail: {
          id: productData.id,
          slug: productData.slug,
          name: productData.name,
          brand: productData.brand,
          is_available: true,
          combination: selectedCombination,
          image: selectedCombination?.images?.find((img) => img.is_cover),
          classification: productData.classification,
        },
        is_selected: true,
        combination: selectedCombination,
      };
    }
  }

  /**
   * Transform product model combinations into a more iterable format for the front end.
   *
   * @param {Array} copyProductCombinations - product.combinations.
   * @param {Array} packDetail - product.pack_detail.
   * @returns {Array} New combination array.
   */
  static transformCombinations(productCombinations, packDetail = []) {
    try {
      const copyProductCombinations = $cloneDeep(productCombinations);
      const transformCombinations = [];
      const isNotPackDetail = Array.isArray(packDetail) && !packDetail.length;
      if (isNotPackDetail) {
        let is_contains_shade = false;
        copyProductCombinations.map((combination, key) => {
          Object.entries(combination.attributes).map(([attributeName]) => {
            copyProductCombinations[key].attributes[
              attributeName
            ].isDisabled = false;
            copyProductCombinations[key].attributes[
              attributeName
            ].isSelected = false;
          });
        });

        if (copyProductCombinations && copyProductCombinations.length) {
          copyProductCombinations.forEach((combination, key) => {
            if (
              combination.attributes &&
              Object.keys(combination.attributes).length &&
              combination.is_active_in_review
            ) {
              let combination_group_name_html = '';
              const combination_group_shade = {};
              let combinationName = '';

              for (const attribute in combination.attributes) {
                let attribute_name;
                // eslint-disable-next-line no-prototype-builtins
                if (combination.attributes.hasOwnProperty(attribute)) {
                  if (
                    attribute !== 'non_specify' &&
                    (combination.attributes[attribute].my_sociolla_sql_id ||
                      combination.attributes[attribute].my_soco_sql_id)
                  ) {
                    combination_group_name_html = combination_group_name_html
                      ? combination_group_name_html + ', '
                      : combination_group_name_html;
                    combinationName = combinationName
                      ? combinationName + ' - '
                      : combinationName;
                    if (
                      combination.attributes[attribute].value !== null &&
                      combination.attributes[attribute].value.search('#') !==
                        -1 &&
                      combination.attributes[attribute].value.length <= 7
                    ) {
                      combination_group_shade.hex =
                        combination.attributes[attribute].value;
                    } else {
                      combination_group_shade.url =
                        combination.attributes[attribute].value;
                    }
                    attribute_name = attribute.replace(
                      /(?:^|\s)\S/g,
                      function (a) {
                        return a.toUpperCase();
                      },
                    );
                    combination_group_name_html += `${attribute_name} - ${combination.attributes[attribute].name}`;
                    combinationName += combination.attributes[attribute].name;
                    if (attribute === 'shade') {
                      combination_group_shade.name = attribute.replace(
                        /(?:^|\s)\S/g,
                        function (a) {
                          return a.toUpperCase();
                        },
                      );
                      is_contains_shade = true;
                    }
                  }
                }
              }

              if (combination_group_name_html) {
                let name_html = combination_group_name_html;
                const explode_combination_to_array = name_html.split(',');

                if (
                  explode_combination_to_array.length > 1 &&
                  explode_combination_to_array[1].indexOf('shade')
                ) {
                  name_html =
                    explode_combination_to_array[1] +
                    ', ' +
                    explode_combination_to_array[0];
                }

                transformCombinations.push({
                  shade: combination_group_shade,
                  name: combinationName,
                  variant: name_html.trim(),
                  images: combination.images,
                  is_contains_shade,
                  _id: combination['_id'],
                  is_active_in_review: combination.is_active_in_review,
                  is_reviewed: combination.is_reviewed,
                  is_verified_purchase: combination.is_verified_purchase,
                });
              }
            }
          });
        }
      }

      return transformCombinations;
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * Returns the discount label text to show on the product grid.
   *
   * Bundle products (`bundle_virtual`/`bundle_physical`, LI-8002): use the
   * top-level `discount_percentage` field instead of `combinations`, since
   * bundles don't populate usable discount data there (see isInStock()).
   *
   * Priority rules (LI-6740):
   *  1. Consider only in-stock combinations (stock > 0 && !(is_out_of_stock_lilla ?? is_out_of_stock_lulla)).
   *  2. Among in-stock combinations with deduction_type === 'percentage', pick the one
   *     with the highest stock quantity (ties are broken by highest percentage).
   *     → Return "<percentage>%"
   *  3. If there are no in-stock percentage combinations but there is at least one
   *     in-stock amount combination → Return "SALE"
   *  4. If no in-stock discounted combinations exist → Return null (hide the label).
   *
   * @returns {string|null} Label text (e.g. "30%", "SALE") or null
   */
  getGridDiscountLabel() {
    // For bundle products, discount data lives in the top-level
    // `discount_percentage` field, not in `combinations`/`default_combination`
    // (same data-shape distinction handled in isInStock() via pack_detail).
    if (
      ['bundle_virtual', 'bundle_physical'].includes(
        this.product?.classification,
      )
    ) {
      if (this.product?.discount_percentage) {
        return `${this.product.discount_percentage}%`;
      }
      if (this.product?.is_sale || this.product?.discount_range) {
        return 'SALE';
      }
      return null;
    }

    const combinations = this.product?.combinations;

    if (!combinations || !combinations.length) {
      // Fallback: single combination product — use default_combination directly
      const dc = this.product?.default_combination;
      if (dc?.deduction_type === 'percentage' && dc?.deduction_percentage) {
        return `${dc.deduction_percentage}%`;
      }
      if (dc?.deduction_type === 'amount') {
        return 'SALE';
      }
      return null;
    }

    const inStock = combinations.filter(
      (c) =>
        c.stock > 0 && !(c.is_out_of_stock_lilla ?? c.is_out_of_stock_lulla),
    );

    const percentageCombos = inStock.filter(
      (c) => c.deduction_type === 'percentage' && c.deduction_percentage,
    );

    if (percentageCombos.length > 0) {
      // Primary sort: highest stock DESC; secondary: highest percentage DESC
      const best = [...percentageCombos].sort(
        (a, b) =>
          b.stock - a.stock || b.deduction_percentage - a.deduction_percentage,
      )[0];
      return `${best.deduction_percentage}%`;
    }

    const hasAmountDiscount = inStock.some(
      (c) => c.deduction_type === 'amount',
    );
    if (hasAmountDiscount) {
      return 'SALE';
    }

    return null;
  }

  /**
   * Checks if the product has exactly two combinations with different attribute types
   * Used for special pricing display logic when combinations have different types (e.g. size and color)
   * @param {Object} combinations - The combinations object with a data array
   * @returns {boolean} - True if there are exactly 2 combinations with different types
   */
  hasTwoCombinationsDifferentType(combinations) {
    const combinationData = combinations?.data || [];
    if (combinationData.length !== 2) {
      return false;
    }

    const [firstCombination, secondCombination] = combinationData;
    const hasValidTypes = firstCombination?.type && secondCombination?.type;

    return hasValidTypes && firstCombination.type !== secondCombination.type;
  }

  /**
   * Returns formatted price discount based on product state and combinations
   * @param {Object} options - Configuration options
   * @param {Object} options.combinations - Product combinations object with data array
   * @param {boolean} options.isUpComingFlashSale - Whether the flash sale is upcoming
   * @param {boolean} options.isFlashSaleProduct - Whether the product is part of a flash sale
   * @param {Object} options.formatters - Formatting functions
   * @param {Function} options.formatters.currencyFormat - Function to format currency
   * @param {Function} options.formatters.formatPrice - Function to format price range
   * @returns {string} Formatted price string
   */
  getFormattedPriceDiscount({
    combinations,
    isUpComingFlashSale,
    isFlashSaleProduct,
    formatters = {},
    statusFlashSale = null,
  }) {
    const { currencyFormat, formatPrice } = formatters;

    // Determine if we're dealing with a single combination scenario
    const hasSingleCombination =
      combinations?.data?.length === 1 ||
      this.hasTwoCombinationsDifferentType(combinations);

    const hasDefaultCombination = !!this.product?.default_combination;

    // If flash sale is sold out (fss)
    if (isFlashSaleProduct && statusFlashSale === 'fss') {
      // Check if have single combination, show its original price
      if (this.product.default_combination && hasSingleCombination) {
        return currencyFormat(this.product.default_combination.price);
      }
      // For multiple combinations, show the price range without discount
      return formatPrice(this.product.price_range);
    }

    // Upcoming flash sale products
    if (isUpComingFlashSale && isFlashSaleProduct) {
      if (hasSingleCombination) {
        return (
          this.product.default_combination?.price_after_discount_format + ' '
        );
      }
      return this.product.price_after_discount_range + ' ';
    }

    // Active flash sale products with a single combination
    if (isFlashSaleProduct && hasDefaultCombination && hasSingleCombination) {
      return currencyFormat(
        this.product.default_combination.price_after_discount,
      );
    }

    // All other products
    return formatPrice(this.product.price_after_discount_range);
  }

  /**
   *
   * Flash Sale
   */

  defineFlashSaleQuota() {
    let sold_quota = 0;
    let total_quota = 0;
    if (this.product.selected_variant) {
      if (this.product.default_combination.sold_quota) {
        sold_quota = this.product.default_combination.sold_quota;
      }
      if (this.product.default_combination.total_quota) {
        total_quota = this.product.default_combination.total_quota;
      }
    } else {
      if (this.product.sold_quota) {
        sold_quota = this.product.sold_quota;
      }
      if (this.product.total_quota) {
        total_quota = this.product.total_quota;
      }
    }

    return {
      sold_quota: Number(sold_quota) > 0 ? Number(sold_quota) : 0,
      total_quota: Number(total_quota),
    };
  }

  getQuotaFlashSale() {
    return this.defineFlashSaleQuota();
  }

  isFlashSaleAlmostEmpty() {
    const quotaFlashSale = this.getQuotaFlashSale();
    return quotaFlashSale.total_quota - quotaFlashSale.sold_quota <= 5
      ? true
      : false;
  }

  getFlashSaleProgressWidth() {
    const maxProgressNumber = 100;
    const quotaFlashSale = this.getQuotaFlashSale();
    const statusFlashSale = this.checkStatusFlashSale();
    let sold = Math.floor(
      ((quotaFlashSale.total_quota - quotaFlashSale.sold_quota) *
        maxProgressNumber) /
        quotaFlashSale.total_quota,
    );
    sold =
      sold > maxProgressNumber ||
      statusFlashSale === 'oos' ||
      statusFlashSale === 'fss'
        ? maxProgressNumber
        : maxProgressNumber - sold;
    const total = maxProgressNumber;

    if (sold > 0) {
      sold = total - sold;
    }

    return {
      sold,
      total,
    };
  }

  checkStatusFlashSale(isFlashSaleEnded) {
    const quotaFlashSale = this.getQuotaFlashSale();
    const sold_quota = quotaFlashSale.sold_quota;
    const total_quota = quotaFlashSale.total_quota;
    if (this.product.selected_variant) {
      if (
        !this.product.default_combination.stock ||
        this.product.default_combination.is_out_of_stock_lulla
      ) {
        return 'oos';
      }
      if ((sold_quota && sold_quota >= total_quota) || isFlashSaleEnded) {
        return 'fss';
      }
      return 'available';
    } else {
      const inStock =
        this.product?.combinations?.filter(
          (c) => c.stock > 0 && !c.is_out_of_stock_lulla,
        ) || [];
      const isStockCombination =
        this.product?.pack_detail && this?.product.pack_detail?.length
          ? true
          : Boolean(inStock.length);
      if (
        !this.product.is_in_stock_original ||
        this.product.is_out_of_stock_lulla ||
        !isStockCombination
      ) {
        return 'oos';
      }
      if (
        (this.product.is_in_stock_original && !this.product.is_in_stock) ||
        isFlashSaleEnded
      ) {
        return 'fss';
      }
      if (
        (this.product.is_in_stock_original && !this.product.is_in_stock) ||
        sold_quota >= total_quota ||
        isFlashSaleEnded
      ) {
        return 'fss';
      }
      return 'available';
    }
  }

  isFlashSaleStillAvailable() {
    const quotaFlashSale = this.getQuotaFlashSale();
    return quotaFlashSale.sold_quota === 0 && quotaFlashSale.total_quota > 0;
  }
}

export const attributesName = (product) => {
  if (
    product &&
    product.combination &&
    ((product.pack_detail && !product.pack_detail.length) ||
      !product.pack_detail)
  ) {
    const name = [];
    const combination =
      product.combination && product.combination.attributes
        ? product.combination.attributes
        : product.combination;
    for (const i in combination) {
      if (i !== 'id' && i !== 'non_specify') {
        name.push({
          group: i,
          value: combination[i].name,
        });
      }
    }
    return name.length ? name : '';
  } else {
    return '';
  }
};

export const sortProductsByPrice = (products, sortType) => {
  if (!sortType) {
    return products;
  }

  return [...products].sort((a, b) => {
    const priceA = parseFloat(a.default_combination?.price_after_discount) || 0;
    const priceB = parseFloat(b.default_combination?.price_after_discount) || 0;

    if (isNaN(priceA) && isNaN(priceB)) {
      return 0;
    }
    if (isNaN(priceA)) {
      return 1;
    }
    if (isNaN(priceB)) {
      return -1;
    }

    if (sortType === 'default_combination.price_after_discount') {
      return priceA - priceB;
    } else if (sortType === '-default_combination.price_after_discount') {
      return priceB - priceA;
    }

    return 0;
  });
};

export default ProductUtils;
